import { useField } from "formik"

import { CreateOrderDialogType } from "../../../createOrderTypes"
import { DeliveryFulfillmentType, DeliveryTimesField, DynamicConfigKey } from "../../form/formTypes"
import { ExtraServicesForDelivery } from "./ExtraServicesForDelivery"

type ExtraServicesProps = Readonly<{
    userId: number
    merchantId: number
    dialogType: CreateOrderDialogType
}>

export function ExtraServices({ userId, merchantId, dialogType }: ExtraServicesProps) {
    const [{ value: deliveryType }] = useField<DeliveryFulfillmentType>(DynamicConfigKey.DELIVERY_TYPE)
    const [{ value: deliveries }] = useField<DeliveryTimesField>(DynamicConfigKey.MULTIPLE_DELIVERIES)

    const deliveryDate = deliveries?.deliveryDate

    if (!deliveryDate || !Array.isArray(deliveries?.deliveryTimes) || deliveries.deliveryTimes.length === 0) {
        return null
    }

    return (
        <>
            {deliveries.deliveryTimes.map((delivery, index) => (
                <ExtraServicesForDelivery
                    key={`extra-svc-${delivery.time}-${index}`}
                    userId={userId}
                    merchantId={merchantId}
                    dialogType={dialogType}
                    deliveryType={deliveryType}
                    deliveryDate={deliveryDate}
                    deliveryTime={delivery.time}
                    deliveryIndex={index}
                />
            ))}
        </>
    )
}
